/* 
PROTECTED PAGE 
*/
import React from "react";
import ProfilePage from "../../Components/ProfilePage/ProfilePage";
import Layout from "../../Components/Layout/Layout";

function ProfileNavPage() {
  return (
    <Layout>
      <ProfilePage />
    </Layout>
  );
}

export default ProfileNavPage;
